// generated by the plop

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AddressType, DirectoryAddressModel, GetAddressesCity, GetAddressesCountry, GetAddressesStreet } from 'shared';
import { PROGRESS_STATUSES } from 'symbols';
import { DirectoryAddressService } from '../../services/directory-address.service';
import { DIRECTORY_ADDRESSES_STATE_DEFAULT, DirectoryAddressesStateModel } from './directory-addresses.model';

@State({ name: 'DirectoryAddresses', defaults: DIRECTORY_ADDRESSES_STATE_DEFAULT })
@Injectable()
export class DirectoryAddressesState {

  @Selector()
  static getAddressesStreet(state: DirectoryAddressesStateModel): string[] {
    return state.currentAddressesStreet.map(v => v.street);
  }

  @Selector()
  static getAddressesCity(state: DirectoryAddressesStateModel): string[] {
    return state.currentAddressesCity.map(v => v.city);
  }

  @Selector()
  static getAddressesCountry(state: DirectoryAddressesStateModel): string[] {
    return state.currentAddressesCountry.map(v => v.country);
  }

  @Selector()
  static loadAddressesStatus(state: DirectoryAddressesStateModel): PROGRESS_STATUSES {
    return state.loadAddressesStatus;
  }

  constructor(private service: DirectoryAddressService) {
  }

  @Action(GetAddressesStreet)
  getAddresses(ctx: StateContext<DirectoryAddressesStateModel>, { textSearch }: GetAddressesStreet): void {
    ctx.patchState({
      loadAddressesStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getDirectoryAddress(textSearch, AddressType.STREET).subscribe({
      next: res => {
        ctx.patchState({
          loadAddressesStatus: PROGRESS_STATUSES.SUCCESS,
          currentAddressesStreet: res
        });
      },
      error: err => {
        ctx.patchState({
          loadAddressesStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }


  @Action(GetAddressesCity)
  getAddressesCity(ctx: StateContext<DirectoryAddressesStateModel>, { textSearch }: GetAddressesCity): void {
    ctx.patchState({
      loadAddressesStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getDirectoryAddress(textSearch, AddressType.CITY).subscribe({
      next: res => {
        ctx.patchState({
          loadAddressesStatus: PROGRESS_STATUSES.SUCCESS,
          currentAddressesCity: res
        });
      },
      error: err => {
        ctx.patchState({
          loadAddressesStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }


  @Action(GetAddressesCountry)
  getAddressesCountry(ctx: StateContext<DirectoryAddressesStateModel>, { textSearch }: GetAddressesCountry): void {
    ctx.patchState({
      loadAddressesStatus: PROGRESS_STATUSES.IN_PROGRESS
    });

    this.service.getDirectoryAddress(textSearch, AddressType.COUNTRY).subscribe({
      next: res => {
        ctx.patchState({
          loadAddressesStatus: PROGRESS_STATUSES.SUCCESS,
          currentAddressesCountry: res
        });
      },
      error: err => {
        ctx.patchState({
          loadAddressesStatus: PROGRESS_STATUSES.FAIL
        });
      }
    });
  }


}


